import backArrow from '../Images/back.png';
import { TbCalendarEvent, TbWorld } from "react-icons/tb";
import {
    MdOutlineContentCopy,
    MdOutlineEmail,
    MdOutlineLocationOn,
    MdOutlineDateRange,
} from "react-icons/md";
import { PiCalendarCheckBold, PiImageBold, PiSealCheck } from "react-icons/pi";
import { GoCreditCard } from "react-icons/go";
import { LuPencilLine } from "react-icons/lu";
import { useEffect, useState } from 'react';

const UserDetails = ({ setDashboardView }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userDetails, setUserDetails] = useState([]);
    const [copied, setCopied] = useState(false);

    const info = [
        {
            icon: <MdOutlineEmail className="text-xl" />,
            label: "Email Address",
            value: userDetails?.email
        },
        {
            icon: <MdOutlineDateRange className="text-xl" />,
            label: "Sign Up Date",
            value: new Date(userDetails?.date_joined).toLocaleString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
            })
        },
        {
            icon: <PiSealCheck className="text-xl" />,
            label: "Wedding Status",
            value: <p className={`${userDetails?.wedding_status === 'Created' ? 'text-[#5314A3] bg-[#ECDFFB]' : 'bg-[#E9EAEC] text-[#0F132499]'} text-sm rounded-md px-[4px] py-0.5`}>{userDetails?.wedding_status === 'Created' ? "Created" : "Not Created"}</p>,
        },
        {
            icon: <GoCreditCard className="text-lg" />,
            label: "Payment Date",
            value: userDetails?.subscribed_date ? new Date(userDetails?.subscribed_date).toLocaleString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
            }) : "N/A",
        },
        {
            icon: <LuPencilLine className="text-xl" />,
            label: "Wedding Name",
            value: userDetails?.weddings?.latest[0]?.name || "N/A",
        },
        {
            icon: <PiCalendarCheckBold className="text-xl" />,
            label: "Wedding Created",
            value: userDetails?.wedding_status === 'Created' ? 'Yes' : 'No',
        },
        {
            icon: <MdOutlineLocationOn className="text-xl" />,
            label: "Wedding Location",
            value: userDetails?.weddings?.latest[0]?.address || "N/A",
        },
        {
            icon: <TbCalendarEvent className="text-xl" />,
            label: "Wedding Date",
            value: userDetails?.weddings?.latest[0]?.event_date ? new Date(userDetails?.weddings?.latest[0]?.event_date).toLocaleString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
            }) : "N/A",
        },
        {
            icon: <TbWorld className="text-xl" />,
            label: "Wedding Slug",
            value: userDetails?.weddings?.latest[0]?.slug || "N/A",
        },
        {
            icon: <PiImageBold className="text-xl" />,
            label: "Cover Image",
            value: userDetails?.weddings?.latest[0]?.landing_page_image ? <img src={userDetails?.weddings?.latest[0]?.landing_page_image} className="w-[40px] h-[30px] object-cover rounded-lg" alt="CoverImg" /> : 'N/A',
        },
    ]


    useEffect(() => {
        const token = localStorage.getItem("PhilomenaAdminToken");

        const fetchData = async () => {
            setLoading(true);
            try {
                const res1 = await fetch(
                    `${process.env.REACT_APP_BACKEND_URL}/admin/get_user_detail?id=${localStorage.getItem('selectedUserId')}`,
                    {
                        method: "GET",
                        headers: { Authorization: `Token ${token}` },
                    }
                );
                const data1 = await res1.json();
                setUserDetails(data1);

            } catch (error) {
                console.error("Error fetching data:", error);
                setError("Failed to fetch user details. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    function getInitials(name) {
        if (!name) return "";
        const parts = name.trim().split(" ");
        const initials = parts
            .slice(0, 2) // Take only first two words
            .map((p) => p.charAt(0).toUpperCase())
            .join("");
        return initials;
    }

    if (loading) {
        return (
            <div className="text-center py-4 flex flex-col items-center justify-center h-[90vh]">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500"></div>
                <span className="text-gray-600">Loading...</span>
            </div>
        );
    }

    if (error) {
        return <p className="p-6 text-red-600">{error}</p>;
    }

    return (
        <div className="sm:py-10 py-5 bg-gray-50 min-h-screen space-y-6">
            {/* User Header */}
            <div
                onClick={() => {
                    window.scrollTo(0, 0)
                    setDashboardView('users')
                    localStorage.setItem('dashboardView', 'users')
                }}
                className='rounded-xl border border-[#DEE0E3] cursor-pointer py-1.5 px-2.5 flex items-center w-fit justify-start gap-1.5'>
                <img src={backArrow} className='size-5' alt="" />
                <p className='font-medium'>Back to Users</p>
            </div>

            <div className="flex mk:flex-row flex-col justify-between mk:items-center">
                <div className="px-3 py-3 flex sp:flex-row flex-col sp:items-center gap-2">
                    <div className="flex items-center justify-center sa:size-16 size-12 sa:text-2xl text-xl rounded-full bg-[#62259A] text-white font-medium">
                        {getInitials(userDetails?.name)}
                    </div>
                    <div className="flex flex-col">
                        <p className="font-medium md:text-2xl sm:text-xl text-lg">{userDetails?.name} <span className={`${userDetails?.status === 'Paid' ? 'text-green-500 bg-green-100' : 'text-red-500 bg-red-100'} text-xs rounded-md px-[3px] py-0.5`}>{userDetails?.status}</span></p>
                        <p
                            className="text-[#0F132499] sm:text-base text-sm"
                        >
                            {userDetails?.email} ·
                            Joined {
                                new Date(userDetails?.date_joined).toLocaleString("en-US", {
                                    day: "numeric",
                                    month: "short",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })}
                        </p>

                    </div>
                </div>
                <div className="flex sc:flex-row flex-col gap-2">
                    <button
                        onClick={async () => {
                            try {
                                const url = `https://${userDetails?.weddings?.latest[0]?.slug}.philomena.events`;
                                await navigator.clipboard.writeText(url);
                                setCopied(true);
                                setTimeout(() => setCopied(false), 2000);
                            } catch (err) {
                                console.error("Failed to copy:", err);
                            }
                        }}
                        className="px-4 py-2 flex items-center gap-2 rounded-xl border border-gray-200"
                    >
                        <MdOutlineContentCopy />
                        {copied ? "Link Copied!" : "Copy Link"}
                    </button>
                    <button
                        onClick={() => window.open(`https://${userDetails?.weddings?.latest[0]?.slug}.philomena.events`, "_blank")}
                        className="px-4 py-2 flex items-center gap-2 rounded-xl bg-[#14151A] text-white hover:bg-[#333]"
                    >
                        <TbWorld />
                        Live Site
                    </button>
                </div>
            </div>

            <div className="grid mk:grid-cols-2 gap-4">
                {info.map((item, index) => (
                    <div key={index} className="text-black/50 w-full py-4 px-5 h-full rounded-md flex sa:flex-row flex-col items-start sa:items-center gap-2 sa:gap-0 justify-between border-[1.5px] border-[#EBECEC] bg-white">
                        <div className="flex items-center gap-2 text-[#0F132466] font-normal mb-1">
                            {item.icon}
                            <p>{item.label}</p>
                        </div>
                        <p className="font-medium text-[#14151A]">{item.value}</p>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default UserDetails;
